import {
  getCoreRowModel,
  useReactTable,
  flexRender,
  getSortedRowModel,
} from '@tanstack/react-table';

import SortIcon from './SortIcon/SortIcon';

import './admin-table.styl';

function AdminTable({
  data = [],
  columns = [],
  className = '',
  initialSorting = [],
}) {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableSortingRemoval: true,
    initialState: {
      sorting: initialSorting,
    },
  });

  return (
    <div className={`admin-table ${className}`}>
      <table className={`admin-table__table z-depth-1 ${className}`}>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                const style = header.column.columnDef.meta?.width ? { width: header.column.columnDef.meta.width } : { flex: 1 };

                return (
                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                    className={header.column.getCanSort() ? 'sortable' : ''}
                    style={style}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                    {header.column.getCanSort() && (
                      <SortIcon sortDirection={header.column.getIsSorted()} />
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => {
                const style = cell.column.columnDef.meta?.width ? { width: cell.column.columnDef.meta.width } : { flex: 1 };

                return (
                  <td key={cell.id} style={style}>
                    {flexRender(
                      cell.column.columnDef.cell,
                      cell.getContext(),
                    )}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminTable;